import React from 'react';

import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import {
  IconButton,
  Popover,
  Grid,
  Typography
} from '@mui/material';
import _ from 'lodash';



export interface IProps {}

export const FC: React.FC<IProps> = props => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);



  function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }



  function handleClose() {
    setAnchorEl(null);
  }



  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <InfoOutlinedIcon sx={{ color : '#528898' }}/>
      </IconButton>

      <Popover
        open={!_.isNil(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left'
        }}>
        <Grid container width={438} alignItems="center" padding={2} sx={{ backgroundColor: '#F0F7FA' }}>
          <Grid item xs={2}>
            <InfoOutlinedIcon sx={{ fontSize: '51px', color : '#528898' }}/>
          </Grid>

          <Grid item xs={10}>
            <Typography fontSize={16} fontWeight={400} color="#528898">
              'Ridge Verified' means that an investor directly provided us with or confirmed this data.
            </Typography>
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};
